var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:{ '--dark': _vm.isDarkMode },attrs:{"id":"app"}},[_c('router-view'),_c('notifications',{attrs:{"group":"foo","position":"bottom center"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }